import { createSelector } from 'reselect';

import { Selector } from 'react-redux';
import { ArticleState } from './articleTypes';
import { RootState } from '../../../core/redux/model/rootStateModel';
import { ArticleGetResponse, ArticleValues } from '../model/articleModel';
import { API_REQUEST_STATE } from '../../../core/enums/apiRequestState';

const getRoot = (state: RootState) => state.article;

export const apiArticleRequestState = createSelector<[Selector<RootState, ArticleState>], API_REQUEST_STATE>(
  getRoot,
  (root: ArticleState) => root.apiArticleRequestState,
);

export const apiArticleRequestError = createSelector<[Selector<RootState, ArticleState>], string | null>(
  getRoot,
  (root: ArticleState) => root.apiArticleRequestError,
);

export const apiArticlesRequestState = createSelector<[Selector<RootState, ArticleState>], API_REQUEST_STATE>(
  getRoot,
  (root: ArticleState) => root.apiArticlesRequestState,
);

export const apiArticlesRequestError = createSelector<[Selector<RootState, ArticleState>], string | null>(
  getRoot,
  (root: ArticleState) => root.apiArticlesRequestError,
);

export const article = createSelector<[Selector<RootState, ArticleState>], ArticleGetResponse>(
  getRoot,
  (root: ArticleState) => root.article,
);

export const articles = createSelector<[Selector<RootState, ArticleState>], ArticleGetResponse[]>(
  getRoot,
  (root: ArticleState) => root.articles,
);

export const initialValues = createSelector<[Selector<RootState, ArticleState>], ArticleValues>(
  getRoot,
  (root: ArticleState) => {
    return {
      title: root.article.title ?? '',
      content: root.article.content ?? '',
      category: root.article.category.iri ?? '',
      categoryOne: {
        value: '',
        key: '',
      },
      categoryTwo: {
        value: '',
        key: '',
      },
      categoryThree: {
        value: '',
        key: '',
      },
      isPublished: root.article.isPublished ?? 'false',
      isNotificationNeeded: root.article.isNotificationNeeded ?? 'false',
      tags: root.article.tags.map((tag) => tag.iri) ?? [],
      keywords: root.article.keywords.map((keyword) => keyword.iri) ?? [],
    };
  },
);
